import { motion } from "framer-motion";

const StarMark = ({ accent }) => (
  <svg viewBox="0 0 64 64" className="h-7 w-7" aria-hidden="true">
    <path
      d="M32 12l5.7 11.5 12.7 1.9-9.2 9 2.2 12.7L32 41.4 20.6 47.1l2.2-12.7-9.2-9 12.7-1.9z"
      fill={accent}
    />
  </svg>
);

export const HeaderBrand = ({ name, description, logoUrl, accent = "#C25E38" }) => (
  <motion.header
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
    className="w-full flex flex-col items-center text-center gap-3 pt-2"
    data-testid="brand-header"
  >
    {logoUrl ? (
      <img
        src={logoUrl}
        alt={`Logo de ${name}`}
        data-testid="brand-logo"
        className="h-16 w-16 rounded-2xl object-cover border border-[#E7E2D7] bg-white shadow-[0_10px_30px_-10px_rgba(28,25,23,0.12)]"
      />
    ) : (
      <div
        data-testid="brand-logo-fallback"
        className="h-16 w-16 rounded-2xl border border-[#E7E2D7] bg-white shadow-[0_10px_30px_-10px_rgba(28,25,23,0.12)] flex items-center justify-center"
      >
        <StarMark accent={accent} />
      </div>
    )}
    <div className="flex flex-col items-center gap-1.5">
      <span
        data-testid="brand-name"
        className="font-serif-display text-2xl font-medium text-[#1C1917] tracking-tight leading-none"
      >
        {name}
      </span>
      {description && (
        <span
          data-testid="brand-description"
          className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[#A8A29E]"
        >
          {description}
        </span>
      )}
    </div>
  </motion.header>
);
